import template from './teamRequestModalRemoveQuestion.html';
import controller from './teamRequestModalRemoveQuestion.controller';
import './teamRequestModalRemoveQuestion.scss';

let teamRequestModalRemoveQuestionComponent = {
  restrict: 'E',
  bindings: {
    message: '@',
    onConfirm: '&',
    isMobileApp: '<'
  },
  template,
  controller
};

export default teamRequestModalRemoveQuestionComponent;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/teamRequests/teamRequestsList/teamRequestCard/teamRequestModalRemove/teamRequestModalRemoveQuestion/teamRequestModalRemoveQuestion.component.js